<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="">客资管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="">客户</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="">编辑</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="add-clue">
            <div class="left-menu">
                <a href="javascript:;">
                    <span>基础信息</span>
                    <a-icon type="right" />
                </a>
            </div>
            <div class="right-content">
                <div class="top-title">
                    基础信息
                </div>
                <div class="add-content">
                    <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                        <a-input v-model="labelitem['id']" hidden></a-input>
                        <a-form-item v-for="(item,i) in system_field_list" :key="i" :label="item.name"> 
                           
                            <a-input v-model="labelitem[item.field_name]" v-if="item.type=='text'||item.type=='mobile'||item.type=='email'" placeholder="请输入"/>
                            <a-select v-model="labelitem[item.field_name]" v-if="item.type=='radio'" placeholder="请选择" style="width: 100%">
                                <a-select-option :value="option" v-for="(option,idx) in item.option_arr" :key="idx">
                                    {{option}}
                                </a-select-option>
                            </a-select>
                            <a-date-picker v-model="labelitem[item.field_name]"  v-if="item.type=='date'"/>
                            <a-textarea v-model="labelitem[item.field_name]" v-if="item.type=='textarea'" placeholder="请输入" :auto-size="{ minRows: 2,maxRows:6}"/>
                        </a-form-item>
     
                    </a-form>
                </div>
               
            </div>
           
        </div>

        <div class="add-clue">
            <div class="left-menu">
                <a href="javascript:;">
                    <span>联系人信息</span>
                    <a-icon type="right" />
                </a>
            </div>
            <div class="right-content">
                <div class="top-title">
                    联系人信息
                </div>

                <div class="clue-list">
                    <a-spin :spinning="tablespinning">
                        <a-table rowKey="id" :columns="columns" :data-source="data" table-layout="auto">
                            <span slot="action" slot-scope="text, record">
                                <a href="javascript:;" class="actionbtn" @click="editcontactshow(record.id)">编辑</a>

                            </span>
                        </a-table>
                    </a-spin>
                </div>
            </div>
        </div>
         

        <div class="add-button">
            <a-button icon="close-circle" theme="filled" @click="quit">取消</a-button>
            <a-button @click="editclue" type="primary" icon="check-circle" theme="filled">保存</a-button>
        </div>


        <!-- 编辑联系人 -->
        <a-modal
            title="编辑联系人"
            :visible="contactvisible"
            :confirm-loading="confirmLoading"
            @ok="contacthandleOk"
            @cancel="handleCancel"
            width="510px"
            okText="确定"
            cancelText="取消"
            >
            <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-form-item label="联系人姓名">
                    <a-input v-model="contactdetail.contact_name" placeholder="请输入联系人姓名"/>
                </a-form-item>
                <a-form-item label="联系人电话">
                    <a-input v-model="contactdetail.mobile_phone" placeholder="请输入联系人电话"/>
                </a-form-item>
            </a-form>
        </a-modal>

    </div>
</template>

<script>
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '姓名',
    dataIndex: 'contact_name',
    key: 'contact_name',
  },
    {
    title: '号码',
    dataIndex: 'mobile_phone',
    key: 'mobile_phone',
  },
   {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    width:'224px'
  },
];

export default {
    data(){
        return{
            fieldlist:"",
            system_field_list:"",
            addresoptions:[],
            labelitem:{},
            labelname:{},

            columns,
            data:[],
            tablespinning:true,
            contactvisible:false,
            confirmLoading:false,
            contactid:"",
            contactdetail:""

        }
    },
 mounted(){
        // 字段
        this.$axios.get('/api/kehufieldlist',{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                is_edit:1
            }
        }).then((res)=>{
            if(res.data.code==200){

                var data=res.data.data.field_list
                var data2=res.data.data.system_field_list
                for(var i in data){
                    data2.push(data[i])
                }
                this.system_field_list=data2
                for(var j in data2){
                    this.labelname[data2[j].field_name]=""
                }
                // alert(JSON.stringify(this.labelitem))
            }else{
                this.$message.warning(res.data.msg);
            }
        }),

        this.$axios.get('/api/getkehudetail',{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                id:this.$route.query.id
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.tablespinning=false
                this.labelitem=res.data.data.info
                this.data=res.data.data.contact_info
                this.labelitem.id=this.$route.query.id
            }
        })

    },
    methods:{
        handleCancel(){
            this.contactvisible=false
        },
        contacthandleOk(){
            this.$axios.post('/api/editcontact',
            {
                id:this.contactid,
                contact_name:this.contactdetail.contact_name,
                mobile_phone:this.contactdetail.mobile_phone
            },{
                headers: {
                    "appid": this.appSet.appid, 
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg);
                    this.contactvisible=false
                    this.$axios.get('/api/getkehudetail',{
                        headers:{
                            "appid": this.appSet.appid,
                            "appkey": this.appSet.appkey,
                            "token":localStorage.getItem('token'),
                        },
                        params:{
                            id:this.$route.query.id
                        }
                    }).then((res)=>{
                        if(res.data.code==200){
                            this.tablespinning=false
                            this.labelitem=res.data.data.info
                            this.data=res.data.data.contact_info
                            this.labelitem.id=this.$route.query.id
                        }
                    })
                }else{
                    this.$message.error(res.data.msg);
                }
            }) 
        },
        editcontactshow(value){
           this.contactvisible=true 
           this.contactid=value
           this.$axios.post('/api/contactdetail',{id:value},{
                headers: {
                    "appid": this.appSet.appid, 
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.contactdetail=res.data.data
                }else{
                    this.$message.error(res.data.msg);
                }
            })

        },
        // 取消
         quit(){
            this.$router.go(-1);
        },
        // 编辑
        editclue(){
            // var data2=this.system_field_list
            // this.labelitem.id=this.$route.query.id
            // var data= JSON.stringify(this.labelitem)
            // // alert(JSON.stringify(settingObj))
            // var arr=new URLSearchParams()
            // arr.append('arr',data)
            // alert(typeof(data))
            this.$axios.post('/api/editkehu',this.labelitem,{
                headers: {
                    "appid": this.appSet.appid, 
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    var id=this.$route.query.id
                    this.$router.push({path: '/customdetail',query:{ id:id}});
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.error(res.data.msg);

                }
            })
        },
        handleChange(){

        },
        date(){

        },
        onPanelChange(value, mode) {

        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/customer/editcustom.vue